import { request } from "@/service/request.js";

// 散客创建订单
export function getCreateOrder(options) {
  return request.call(this, {
      url: "openapi/web/individual/createOrder",
      method: 'POST',
      data:options
  });
}

// 免费散客创建订单
export function getFreeCreateOrder(options) {
  return request.call(this, {
      url: "openapi/web/free/createOrder",
      method: 'POST',
      data:options
  });
}
